"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MilliSecond = exports.Year = exports.Week = exports.Day = exports.Hour = exports.Minute = void 0;
var uom_1 = require("uom");
// Duration / Time
exports.Minute = uom_1.Unit.timesNumber("Minute", 60.0, uom_1.BaseUnits.Second);
exports.Hour = uom_1.Unit.timesNumber("Hour", 60.0, exports.Minute);
exports.Day = uom_1.Unit.timesNumber("Day", 24.0, exports.Hour);
exports.Week = uom_1.Unit.timesNumber("Week", 7.0, exports.Day);
exports.Year = uom_1.Unit.timesNumber("Year", 8760.0, exports.Hour);
exports.MilliSecond = uom_1.UnitPrefix.Milli("MilliSecond", uom_1.BaseUnits.Second);
//# sourceMappingURL=duration.js.map